const rankings = [
  { rank: 1, title: '某顶流男星被曝隐婚生子三年', hot: '987.2万', tag: '🔥 爆', trend: 'up' },
  { rank: 2, title: '直播圈头部主播偷税案最新进展', hot: '865.4万', tag: '🔥 热', trend: 'up' },
  { rank: 3, title: '某综艺导演组内幕录音完整版流出', hot: '742.1万', tag: '🔥 热', trend: 'up' },
  { rank: 4, title: '夫妻档网红宣布离婚内幕持续发酵', hot: '653.8万', tag: '📈 升', trend: 'up' },
  { rank: 5, title: '知名品牌代言人丑闻波及股价', hot: '521.3万', tag: '📈 升', trend: 'up' },
  { rank: 6, title: '某影视公司内部邮件曝光行业潜规则', hot: '489.6万', tag: '🆕 新', trend: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">话题热榜</h2>
            <p className="text-sm text-foreground-500">全网吃瓜热度实时排行，一分钟了解最热话题</p>
          </div>
          <div className="max-w-3xl mx-auto bg-background-50 rounded-lg border border-background-300/40 overflow-hidden">
            {rankings.map((item, i) => (
              <a
                key={i}
                href="#cards"
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100/70 transition-all duration-200 cursor-pointer ${
                  i < rankings.length - 1 ? 'border-b border-background-300/30' : ''
                }`}
              >
                <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-primary-500/80 text-background-50' :
                  item.rank === 3 ? 'bg-primary-500/60 text-background-50' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm text-foreground-800 truncate">{item.title}</h3>
                </div>
                <span className="text-xs text-foreground-500 flex-shrink-0 whitespace-nowrap">{item.tag}</span>
                <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap">{item.hot}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}